import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Card, CardBody, Col, CardHeader, Row
} from 'reactstrap';
import { NoDataToDisplay } from 'react-highcharts-no-data-to-display';
import ReactHighChart from 'react-highcharts/ReactHighcharts.src';

import ChartReportApi from 'apis/reports/ChartReport';
import { getPlotOptions, getToolTip } from 'utils/chartHelpers';
import Filters from './Filters';
import { generateChartConfig } from 'utils/generateChartConfig';
import ChartSkeleton from '../skeleton-uis/charts/ChartSkeleton';
import NoSurveyTemplateError from './NoSurveyTemplateError';

NoDataToDisplay(ReactHighChart.Highcharts);

class ChartReport extends Component {
  constructor() {
    super();
    this.state = {
      isSurveyTemplateQuestion: true,
      isLoading: true,
      filter: {},
      errorText: '',
      filters: null,
      seriesData: {},
    }
  }

  componentWillMount = () => {
    const { filters } = this.props;

    if (filters) {
      this.setState({ filter: filters[0] }, this.updateChart);
    } else {
      this.updateChart();
    }
  }

  componentDidUpdate = (prevProps) => {
    const { startDate, endDate } = this.props;
    if (startDate !== prevProps.startDate || endDate !== prevProps.endDate) {
      if ((startDate && endDate) || (!startDate && !endDate)) {
        this.updateChart();
      }
    }
  }

  updateChart = () => {
    const { startDate, endDate, questionId, category, filterType, dataType: chart_type } = this.props;
    const { filter } = this.state;
    const start_date = startDate;
    const end_date = endDate;
    let filters = null;

    if (filterType) {
      filters = {};
      filters[filterType] = filter ? filter.name : "";
    }

    this.setState({ isLoading: true });
    ChartReportApi.getAll(questionId, filters, category, chart_type, start_date, end_date).then(({ data }) => {

      if (typeof data === 'string') {
        this.setState({
          isSurveyTemplateQuestion: false, isLoading: false, errorText: data
        });
        return;
      }

      this.setState((prevState) => ({
        seriesData: data, isLoading: false, isSurveyTemplateQuestion: true
      }));
    }).catch(e => {
      console.log(e)
      this.setState({ isLoading: false })
    });
  }

  onFilter = (filterValue) => {
    const { filter } = this.state;
    if (filterValue != filter) {
      this.setState({ filter: filterValue }, this.updateChart);
    }
  }

  renderChartBody = () => {
    const { isLoading, filter, seriesData, isSurveyTemplateQuestion, errorText } = this.state;
    const {
      titleText, subtitleText, chartType, filters, stacked, colors, axisTitle, percentage, legendConfig, height, filterSeperatorIndex
    } = this.props;
    const chartConfig = generateChartConfig({
      seriesData,
      chartType,
      titleText,
      subtitleText,
      legendConfig,
      yAxisTitle: axisTitle,
      stacked,
      colors,
      percentage,
      height
    });

    if (isLoading) {
      return <ChartSkeleton chartType={chartType} />
    }

    return (
      <Fragment>
        <NoSurveyTemplateError isSurveyTemplateQuestion={isSurveyTemplateQuestion} errorText={errorText} />
        <div className={!isSurveyTemplateQuestion ? 'invisible' : ''}>
          <ReactHighChart
            config={chartConfig} />
          {filters && (<span className="filter-container">
            <Filters filterSeperatorIndex={filterSeperatorIndex} filters={filters} onFilter={this.onFilter} filter={filter} />
          </span>)}
        </div>
      </Fragment>
    )
  }

  render() {
    let { headTitle, showGrids, containerClassName } = this.props;
    const { isLoading } = this.state;
    const gridsClassName = showGrids ? '' : 'hide-chart-grids';
    containerClassName = isLoading ? 'w-100' : containerClassName;

    return (
      <Row className={containerClassName}>
        <Col className="p-0 my-0">
          <Card className="rounded-0">
            {headTitle && (
              <CardHeader className="chart-group-head text-center">
                {headTitle}
              </CardHeader>)}
            <CardBody className={gridsClassName}>
              {this.renderChartBody()}
            </CardBody>
          </Card>
        </Col>
      </Row>
    )
  }
}

ChartReport.defaultProps = {
  height: 300
};

ChartReport.propTypes = {
  height: PropTypes.number,
  filters: PropTypes.array,
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  questionId: PropTypes.number,
  category: PropTypes.string,
  filterType: PropTypes.string,
  dataType: PropTypes.string,
  titleText: PropTypes.string,
  subtitleText: PropTypes.string,
  chartType: PropTypes.string,
  stacked: PropTypes.bool,
  colors: PropTypes.array,
  axisTitle: PropTypes.string,
  percentage: PropTypes.bool,
  legendConfig: PropTypes.object,
  headTitle: PropTypes.string,
  showGrids: PropTypes.bool,
};

export default ChartReport;




// WEBPACK FOOTER //
// ./src/components/charts/Chart.jsx